const actions = {
  GET_REPORTS_STATISTICS_REQUEST: "GET_REPORTS_STATISTICS_REQUEST",
  GET_REPORTS_STATISTICS_SUCCESS: "GET_REPORTS_STATISTICS_SUCCESS",

  //Actions

  getReporstStatistics: (organizationId, restaurantId, startDate, endDate) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_REPORTS_STATISTICS_REQUEST,
        organizationId,
        restaurantId,
        startDate,
        endDate,
      });
    };
  },
};
export default actions;
